import { getDeptTreeList } from "@/apis/dept.api";
import type { DeptTreeItem } from "@/types/apis";
import { useQuery } from "@tanstack/react-query";
import type { TreeDataNode } from "antd";

function convertDeptDataToTreeData(data: DeptTreeItem[]): TreeDataNode[] {
  const treeData = data.map((item) => {
    return {
      title: item.label,
      key: item.id,
      children: convertDeptDataToTreeData(item.children),
    };
  });

  return treeData;
}

// 获取部门tree列表
export function useDeptTreeList() {
  const { data: res } = useQuery({
    queryKey: ["deptTreeList"],
    queryFn: () => getDeptTreeList(),
  });

  const data = convertDeptDataToTreeData(res?.data.data || []);

  return {
    deptTreeData: data,
  };
}
